import Flickity from 'flickity';

const carousels = [];

export default function () {
  document.querySelectorAll('[data-blog-tags-carousel]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    el.setAttribute('initialized', 'true');

    const carousel = new Flickity(el, {
      contain: true,
      groupCells: true,
    });

    carousels.push(carousel);
  });
}
